import { SVGIcon } from '@superops/super-icons';
import { Button, TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage } from 'react-intl';

function SubjectCell(props) {
  const { cell } = props;
  const { value } = cell || {};
  const { actions = () => {} } = cell.column || {};

  const allProps = {
    ...cell,
    ticketId: cell.row.original.ticketId,
    module: 'TICKET',
    data: {
      subject: cell?.row?.original?.subject,
      displayId: cell?.row?.original?.displayId,
      ticketId: cell?.row?.original?.ticketId
    }
  };
  return value ? (
    <>
      <div className="fx actr full-width" id={value} key={value}>
        <Button
          icon={<SVGIcon name="TicketFilled" size="sm" />}
          onClick={actions?.onClick.bind(this, allProps)}
          plain
        >
          {value}
        </Button>
      </div>
    </>
  ) : (
    <>
      <TextStyle variation="subdued">
        <FormattedMessage id="app.noData.message" />
      </TextStyle>
    </>
  );
}

export default React.memo(SubjectCell);
